import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "knRotate" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "phone" }, null, -1)
const _hoisted_3 = { class: "message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.rotateDevice')), 1)
  ]))
}